import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'td-wb-card-title',
  template: '<ng-content />',
  styleUrls: ['card-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardTitleComponent {
}
